
export class IdTools {

    static makeId(length) {
        return this.genId(length, 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789');
    }

    static makeIdAllChars(length){
        return this.genId(length, 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890');
    }

    static genId(length, characters) {
		var result           = '';
		var charactersLength = characters.length;
		for ( var i = 0; i < length; i++ ) {
		   result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		console.log('Unique id generated:'+result);
		return result;
	}
}